<nbl-municipality-form class="ambita-report-block">
  <h3 class="ambita-nbl-personal-form__heading ambita-report-h3 break-before">Nabovarsel</h3>
  <p>
    Opplysninger gitt i nabovarsel<br>
    sendes kommunen sammen med søknaden<br>
    (Gjenpart av nabovarsel)<br>
    plan- og bygningsloven av 27. juni 2008 nr 71 § 21-3
  </p>

  <table class="table">
    <thead>
    <tr>
      <th colspan="6">Tiltak på eiendommen:</th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td colspan="2">
        <sup>Gnr.</sup> {opts.cadastre.gnr}
        <sup>|Bnr.</sup> {opts.cadastre.bnr}
        <sup>|Festenr.</sup> {opts.cadastre.fnr}
        <sup>|Seksjonsnr</sup> {opts.cadastre.snr}
      </td>
      <td colspan="2">
        <sup>Adresse</sup> {opts.address.title}
      </td>
      <td colspan="2">
        <sup>Postnr.</sup> {opts.address.postcode}
        <sup>|Poststed</sup> {opts.address.city}
      </td>
    </tr>
    <tr>
      <td colspan="3">
        <sup>Eier/fester</sup> {opts.owner.name}
      </td>
      <td colspan="3">
        <sup>Kommune</sup> {opts.cadastre.knr}
      </td>
    </tr>
    </tbody>
  </table>
  <nbl-notification-schema prefill-schema="{ opts.prefillSchema }"></nbl-notification-schema>
  <script>
    import './neighborListPersonalForm.scss';
    import './neighborListNotificationSchema.tag';
  </script>
</nbl-municipality-form>
